module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABEklEQVQoU42SoU7EQBCG/1lTGkwlvATBnEAiUJecR9TtrkOSYAghGJJTGMRMXQWWXHgCkCjgAcDduSpSKmDIQAvlOC6smcns/+2/Ozvkvd8hIgGwQkSqqiMAA3yuWyKaqCoBeAHgKYTwZKKiKO5bEWKMB5Yz82lXCyFsArg0YCYia92GxUVAW59RjHHKzOv/BKZfgPd+t2maSVmWz32HPM9XkySxK1/Y4X3gyDm3Xdf1ME3TPXOsquosy7IrIrpm5uMfgAlCCGMiGqjqDYA3AFsA7kRkv33Dt0OvGwaZw6uqnnfiP4HW6cSiiBzONeO3Q18wn8cYP9r6CGDEzA/LxN77Dft1stFwzrGNxjLARkNVwzswQJTbdqNu+QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fig-download.png
// module id = bAjq
// module chunks = 1